import React from 'react';
import * as Config from '../../../config';
import PropTypes from 'prop-types';
import { Root, Trigger } from "@radix-ui/react-context-menu";

import MidDropBoxV3 from '../dnd/MidDropBoxV3';
import CoverSplit from '../common/CoverSplit';
import More from '../common/More';

import useFullPlaylistMenu from './hooks/useFullPlaylistMenu';

function PlaylistMenu({
  playlist, index, style, draggable = false,
  name, track_count, length_ms = null, containerRef = null
}) {

  const {
    match, setHistory,
    availableDrop, opacity, refDrop,
    deleteFormPlaylist,
    id, to, cover, showContextMenu, ContextMenuContent, onRightClick,
    onReorder, dragRef, isDraggingPlaylists
  } = useFullPlaylistMenu(playlist, draggable);
  
  const styleMidDropBox = {
    backgroundColor : `transparent`, zIndex: 20, position: `absolute`,
    width: '95%',
    height: 28,
    opacity: 0,
  }

  return (
    <Root modal={false}>
      <Trigger>
        <div id={`menu-left-container-${index}`} ref={dragRef} className={`menu-left-container ${match && `selected`} allow-menu`} onContextMenu={onRightClick} >
          <div id={`PM-D-${id}`} onClick={deleteFormPlaylist} />
          <div id={`link-ref-${id}`} onClick={setHistory} style={{textDecoration: `none`}} to={to}>
            <div id={`ref-${id}`} className={`playlist-container ${match && `selected`} ${availableDrop && `droppable`} `} ref={refDrop} style={{
              display: `flex`, flexDirection: `row`, flexWrap: `nowrap`, alignContent: `flex-start`, justifyContent: `flex-start`,
              ...style, opacity, cursor: (availableDrop) ? `copy` : `default`
            }} >
              <CoverSplit name={name} images={cover} size={Config.MENU_COVER_SIZE} draggable={false} />
              <div className={`flexColumn playlist-menu-infos type-small`}>
                <span className={`type-medium fz13`} >{Config.limitString(name, 15, false)}</span>
                <span className={`playlist-menu-owner`}>{`${track_count} tracks`}</span>
                {/* <span className={`playlist-menu-owner`}>{`${track_count} tracks • ${Config.msToHourMin(length_ms)}`}</span> */}
              </div>
              <div id={`playlist-drop-top-${index}`} style={{ ...styleMidDropBox, top: -1, borderTop: `1px solid ${Config.BRAND_PRIMARY}` }} />
              <div id={`playlist-drop-bottom-${index}`} style={{ ...styleMidDropBox, bottom: -1, borderBottom: `1px solid ${Config.BRAND_PRIMARY}` }} />
            { isDraggingPlaylists && (
              <>
                <MidDropBoxV3 active={(index === 0) ? `playlist-drop-top-${index}` : `playlist-drop-bottom-${index - 1}`} containerRef={containerRef} containerRefLvl={0} accept={[`PLAYLIST-MENU`]} drop={onReorder(index - 1)} style={{ ...styleMidDropBox, top: -1, borderTop: `1px solid ${Config.BRAND_PRIMARY}` }} />
                <MidDropBoxV3 active={`playlist-drop-bottom-${index}`} containerRef={containerRef} containerRefLvl={0} accept={[`PLAYLIST-MENU`]} drop={onReorder(index)} style={{ ...styleMidDropBox, bottom: -1, borderBottom: `1px solid ${Config.BRAND_PRIMARY}` }} />
              </>
            )}  
            </div>
          </div>
          <More id={`more-ref-${id}`} size={24} className={`playlist-more`} onClick={showContextMenu} />
        </div>
      </Trigger>
      { ContextMenuContent && <ContextMenuContent /> }
    </Root>
  )
}

PlaylistMenu.propTypes = {
  playlist: PropTypes.object.isRequired,
  index: PropTypes.number,
  style: PropTypes.object,
  name: PropTypes.string,
  track_count: PropTypes.number,
  draggable: PropTypes.bool,
}

export default PlaylistMenu;
